(function ($) {
    $.fn.frontPageHero = function(){

        // Remove frontpage animation for safari scroll fix
        const removeFrontPageHeroAnimation = () => {
            
            let animationTime = 1.8;
            
            if(window.themeData.frontPageAnimationParams){
                if(
                    window.themeData.frontPageAnimationParams.duration &&
                    window.themeData.frontPageAnimationParams.duration !== '' &&
                    window.themeData.frontPageAnimationParams.duration.match(/^-?\d*(\.\d+)?$/)){
                        animationTime = parseFloat(window.themeData.frontPageAnimationParams.duration);
                }
            }

            // Remove animation after end
            setTimeout(() => {
                $('.front_page_hero.banner-hero .parallax-layer.parallax-layer-1 .circle').css('animation', 'unset');
            }, (animationTime * 1000));
        };
        
        this.each((index, element) => {
            
            const $self = $(element);

            $self.find('.card-link').each((cardIndex, card) => {
            
                card.addEventListener('mouseenter', function(){
                    let cardHeight = $(card).find('.content').height();
                    let content = $(card).find('.content-container');
                    let contentHeight = $(content).height();
                    let oldHeight = contentHeight;

                    do{
                        oldHeight = contentHeight;
                        $(content).css('padding-top', ((cardHeight - contentHeight) / 2) + 'px');
                        contentHeight = $(content).height();
                    }
                    while(oldHeight > contentHeight);
                });
            });
        });

        removeFrontPageHeroAnimation();
        return this;
    }

    $(() => {
        $('.front_page_hero').frontPageHero();
    })

})($);




// WEBPACK FOOTER //
// ./scripts/modules/blocks/front-page-hero.js